import gdriveIcon from 'assets/images/gdrive.svg';
import { GenericConnection } from './generic-connection';
import { Integration } from 'services/integration-service';

/**
 * Google Drive Connection Component
 * 
 * Provides interface for connecting Google Drive to the application.
 * Uses the generic connection component with Google Drive specific configuration.
 * 
 * @param onBack - Callback function to go back to connectors list
 * @param existingIntegration - Existing integration if any
 * @returns A Google Drive connection interface
 */

interface GoogleDriveConnectionProps {
    onBack: () => void;
    existingIntegration?: Integration;
}

const googleDriveConfig = {
    id: 'google-drive',
    name: 'Google Drive',
    description: 'GOOGLE_DRIVE_DESCRIPTION',
    longDescription: 'GOOGLE_DRIVE_LONG_DESCRIPTION',
    icon: gdriveIcon,
    iconAlt: 'Google Drive',
    category: 'Productivity',
    developer: 'OpenAI',
    website: 'https://drive.google.com',
    privacyPolicy: 'https://policies.google.com/privacy'
};

export const GoogleDriveConnection = ({ onBack, existingIntegration }: GoogleDriveConnectionProps) => {
    return (
        <GenericConnection
            onBack={onBack}
            integrationConfig={googleDriveConfig}
            existingIntegration={existingIntegration}
        />
    );
};
